const ProtectedRoute = ({ element, feature, redirectTo = "/" }) => {
  const isAllowed = feature;
  return isAllowed ? element : <h2 className="flex align-items-center justify-content-center">404 Not Found</h2>;
};

export default ProtectedRoute;
